<template>
    <div class="main-body">
        <div class="header">
            商品分类
        </div>
        <div class="out">
            <div class="search2">

                <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">分类选择</el-button>
                <el-button style="padding:3px 5px">
                    <el-checkbox v-model="checked" @change="getData">只显示正常分类</el-checkbox>
                </el-button>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableDatas" :height="th" border style="width: 100%;"
            row-key="goodsClassGovernmentCode"
            :row-class-name="tableRowClassName"
            :tree-props="{children: 'goodsClassGovernmentList'}">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="icon" label="图标">
                    <template slot-scope="scope">
                        <el-popover placement="right" title="" trigger="click">
                            <img :src="imgUrl+scope.row.icon"  style="width: 500px"/>
                            <img slot="reference" :src="imgUrl+scope.row.icon" style="width:50px">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <el-tag type="success" v-show="scope.row.status==1">正常</el-tag>
                            <el-tag type="danger" v-show="scope.row.status==2">禁用</el-tag>
                        </template>
                </el-table-column>
            </el-table>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:goodsClassList='goodsClassList' v-on:getList="getList"></Add>
        <!-- <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:goodsClassList='goodsClassList' v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:[],
                tableDatas:[],
                goodsClassList:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                hxData:[],
                status:-1,
                attributeList:[],
                statusValue:[[-1,'全部状态'],[1,'正常'],[2,'禁用']],
                imgUrl:this.$imgUrl,
            }
        },
        components:{
            Add
        },
        created(){
            this.init()
            this.getList();
            this.th = this.$store.state.tableHeight+50;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val+50;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.goodsClassList = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(this.hxData);
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClassGovernment/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    _this.tableLoading=false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                        this.getData()
                        for(var i in this.tableData){
                            for(var j in this.tableData[i].goodsClassGovernmentList){
                                this.hxData.push(this.tableData[i].goodsClassGovernmentList[j].goodsClassCode)
                            }
                        }
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false;
                    console.log(error);
                });
            },
            tableRowClassName({row}) {
                if (row.status == 2) {
                    return 'success-row';
                }
                return '';
            },
            getData(){
                var data=[]
                if(!this.checked){
                    data=this.tableData
                }else{
                    this.tableData.forEach(val=>{
                        if(val.status==1){
                            var list=val
                            if(val.goodsClassGovernmentList.length>0){
                                var list1=[]
                                val.goodsClassGovernmentList.forEach(val1=>{
                                    if(val1.status==1){
                                        list1.push(val1)
                                    }
                                })
                                list.goodsClassGovernmentList=list1
                            }
                            data.push(list)
                        }
                    })
                }
                this.tableDatas=data
            },
            statusTitle(row){
                if(row.status == 1){
                    return "正常";
                }
                if(row.status == 2){
                    return "禁用";
                }
                return "其它";
            },



        }
    }
</script>

<style lang="scss" scoped>
    .goodsClassGov{
        /deep/ .el-table .cell .el-table__indent{
            padding-left: 50px !important;
        }
        /deep/ .el-table .success-row {
            background:#EBEEF5;
        }
    }

</style>
